import { useQuery } from '@tanstack/react-query'
import {
  fetchPlanSubmissions,
  type PlanSubmissionRead,
} from '@/api/submissions'
import { queryKeys } from '@/lib/queryKeys'

/**
 * Hook for fetching the submission history of a plan's active version.
 */
export function usePlanSubmissions(planId: string) {
  return useQuery<PlanSubmissionRead[]>({
    queryKey: queryKeys.submissions.byPlanId(planId),
    queryFn: () => fetchPlanSubmissions(planId),
    enabled: !!planId,
  })
}
